import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NarrativeStep from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.narrative,
    actualContext: state.steps.context,
    app: state.app,
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NarrativeStep));



// WEBPACK FOOTER //
// ./src/components/NarrativeStep/container/index.js